import React, { useState } from 'react';
import { Check, ContentCopy } from '@mui/icons-material';
import { IconButton } from 'library/ui';

export default function CopyButton({ value }: { value: string }) {
    const [copied, setCopied] = useState(false);

    function copy() {
        navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    }

    return (
        <IconButton
            icon={copied ? Check : ContentCopy}
            onClick={copy}
            tooltip={copied ? 'Copied' : 'Copy'}
            size={28}
            iconSize={16}
        />
    );
}
